import DateFnsUtils from "@date-io/date-fns";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import MaterialTable, { MTableToolbar } from "material-table";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSuppliers } from "../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import { getSessionData } from "../../base/helper/baseHelper";
import Base from "../../base/views/base";
import SelectableSearch from "../../base/views/SelectableSearch";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import { getReconcillationReport } from "../helper/reportHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
      widht: "100%",
    },
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  mainCon: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
}));

function ReconcillationReport(props) {
  const classes = useStyles();

  const [userId, setUserId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [invoiceDate, setInvoiceDate] = React.useState(new Date());
  const [gridData, setGridData] = React.useState([]);
  const [tableData, setTableData] = React.useState([]);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });
  const [reportState, setReportState] = React.useState({
    user_id: userId,
    store_id: storeId,
    from_date: "",
    to_date: "",
    selectedSupplier: { id: 0, optionname: "" },
  });

  const [filterValue, setFilterValue] = React.useState();

  const filterOptions = [
    { filterid: 1, filterName: "All" },
    { filterid: 2, filterName: "Rx variance" },
    { filterid: 3, filterName: "OTC variance" },
    { filterid: 4, filterName: "All variance" },
  ];

  // eslint-disable-next-line
  const getLastWeek = () => {
    var today = new Date();
    var lastWeek =
      today.getFullYear() +
      "/" +
      (today.getMonth() + 1) +
      "/" +
      (today.getDate() - 7);
    return new Date(lastWeek);
  };

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    // eslint-disable-next-line
  }, [userId, storeId]);

  const handleInvoiceDateChange = (date) => {
    setInvoiceDate(date);
  };

  const loadReport = (e) => {
    var iDate = new Date(invoiceDate);
    var strInvoiceDate =
      iDate.getFullYear() +
      "/" +
      (iDate.getMonth() + 1) +
      "/" +
      iDate.getDate();

    var strSupplier =
      reportState.selectedSupplier.optionname !== undefined
        ? reportState.selectedSupplier.optionname
        : "";

    getReconcillationReport(
      userId,
      storeId,
      strInvoiceDate,
      strInvoiceDate,
      strSupplier
    )
      .then((response) => {
        if (response && response.length > 0) {
          setGridData(response);
          setTableData(response);
          setFilterValue(1);
        } else {
          setGridData([]);
          setTableData([]);
        }
      })
      .catch((err) => {});
  };

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setReportState({
        ...reportState,
        selectedSupplier: { id: value.id, optionname: value.optionname },
      });
    } else {
      setReportState({
        ...reportState,
        selectedSupplier: {},
      });
    }
  };

  const handleChange = (e) => {
    setFilterValue(e.target.value);
    if (e.target.value === 1) {
      setTableData(gridData);
    } else if (e.target.value === 2) {
      const data = gridData.filter(
        (data) => data.producttype === "RX" && data.variance !== "0"
      );
      setTableData(data);
    } else if (e.target.value === 3) {
      const data = gridData.filter(
        (data) => data.producttype === "OTC" && data.variance !== "0"
      );
      setTableData(data);
    } else if (e.target.value === 4) {
      const data = gridData.filter((data) => data.variance !== "0");
      setTableData(data);
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Inventory Reconcillation Report">
        <CssBaseline />
        <Grid container spacing={3} style={{ marginTop: "1.5%" }}>
          <Grid item xs={12} sm={3}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid justify="space-around">
                <KeyboardDatePicker
                  margin="normal"
                  id="invoiceDate"
                  label="Invoice Date"
                  format="MM/dd/yyyy"
                  autoOk={true}
                  okLabel={""}
                  cancelLabel={""}
                  value={invoiceDate}
                  autoFocus
                  onChange={handleInvoiceDateChange}
                  className={classes.submit}
                  fullWidth
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{ paddingTop: 25 }}>
              <SelectableSearch
                value={reportState.selectedSupplier}
                data={supplierData}
                name="supplier"
                label="Supplier"
                id="supplier"
                loading={loadSupplierDropdown}
                onChangeEvent={handleSupplierChange}
                variantType="standard"
              ></SelectableSearch>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              onClick={(e) => {
                loadReport(e);
              }}
              fullWidth={true}
              color="primary"
              variant="contained"
              size="medium"
              style={{
                marginTop: "7%",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
            >
              Generate
            </Button>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <MaterialTable
            title=""
            columns={[
              {
                title: "Supplier",
                field: "suppliername",
                defaultSort: "asc",
              },
              { title: "Inv-Date", field: "invoicedate" },
              {
                title: "Description",
                field: "description",
                cellStyle: {
                  width: "40%",
                },
              },
              { title: "NDC", field: "ndc" },
              { title: "Inv-Qty", field: "invoicequantity" },
              { title: "Rec-Qty", field: "receivedqty" },
              { title: "Var", field: "variance" },
            ]}
            data={tableData}
            components={{
              Toolbar: (props) => (
                <Box display="flex">
                  <Box display="flex" style={{ width: "200px" }}>
                    <FormControl
                      style={{ display: "flex" }}
                      variant="outlined"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel id="filterlabel">View By</InputLabel>
                      <Select
                        labelId="filterlabel"
                        name="filterValue"
                        id="panselectoutlined"
                        label="View By"
                        value={filterValue}
                        onChange={(e) => handleChange(e)}
                      >
                        {filterOptions.map((option) => (
                          <MenuItem
                            key={option.filterid}
                            value={option.filterid}
                          >
                            {option.filterName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box flexGrow={1}>
                    <MTableToolbar {...props} />
                  </Box>
                </Box>
              ),
            }}
            options={{
              maxBodyHeight: 670,
              paging: true,
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              headerStyle: {
                backgroundColor: "rgba(255,255,255,1)",
                color: "black",
              },
              exportButton: true,
              exportAllData: true,
            }}
          />
        </div>
        {/* </Container> */}
        {/* </Container> */}
        <LandingPageFooter />
      </Base>
    </div>
  );
}

const mapStateToDispatch = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(ReconcillationReport);
